/**
 * shadcn/ui Label — vendored + tokenized for CertAIn v2 (Phase 1 fan-out foundation).
 *
 * Radix Label with the shadcn CVA. Text color set to the CertAIn semantic
 * `text-text-primary` so it resolves inside `[data-theme="v2"]`. Guard-clean.
 *
 * Used by every v2 form field label (patterns/FormFieldV2 pairs it with Input /
 * Select / Textarea across JD forms, Candidate new, Settings).
 */
import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const labelVariants = cva(
  "text-[13px] font-medium leading-none text-text-primary peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
);

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof labelVariants>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(labelVariants(), className)}
    {...props}
  />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
